define(['app', './ajax-link', 'jquery'], function (app, ajaxLink, $) {
  return ajaxLink.extend({
    counter: null,
    options: {
      callBack: function () {
        var url = this.$el.attr('href')
        var urlReplace = ''
        var isFollowersTab = window.location.href.indexOf('/network/followers') > 0
        this.$el.toggleClass('is-follow')
        this.counter = this.counter || (isFollowersTab ? $('.js-following') : $('.js-followers'))
        var val = parseInt(this.counter.text(), 10)
        if (this.$el.hasClass('is-follow')) {
          urlReplace = url.replace('follow', 'unfollow')
          this.$el.attr('href', urlReplace)
          this.$el.children('.unfollow').removeClass('is-hidden')
          this.$el.children('.follow').addClass('is-hidden')
          this.$el.data('params', { '_': Date.now() })
          this.counter.text(val + 1)
        } else {
          urlReplace = url.replace('unfollow', 'follow')
          this.$el.attr('href', urlReplace)
          this.$el.children('.follow').removeClass('is-hidden')
          this.$el.children('.unfollow').addClass('is-hidden')
          this.$el.data('params', { '_': Date.now() })
          this.counter.text(val - 1)
        }
      }
    },
    events: {
      click: 'ajaxLink'
    }
  })
})
